import { useTranslation } from "react-i18next";
import { getTranslatedLabel } from "../../../utils/helpers";
import { getFormFieldOptions } from "../../../redux/reducer/formReducer";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../redux";

function ButtonsRadioRHF(props: any) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { register, formField, errors } = props;
  const label = getTranslatedLabel(formField.translations);

  /**
   * state variable.
   */
  const [options, setOptions] = useState([]);

  /**
   * fetch options
   */
  useEffect(() => {
    if (formField._id) {
      fetchOptions(formField._id);
    }
  }, [formField._id]);

  const fetchOptions = async (id: any) => {
    const options = await dispatch(getFormFieldOptions(id));
    if (options) {
      setOptions(options);
    }
  };

  return (
    <div className="ButtonsRadio pb-2">
      {options.map((option: any, key: number) => (
        <span key={key} className="mr-5">
          <input {...register} type="radio" value={option.key} />
          <label className="ms-2 radio-label">{option.name}</label>
        </span>
      ))}

      {errors[formField.name] && (
        <div className="validation-errors-text-size text-danger mt-1 ms-2">
          {t("dynamic-form.required", { param: label })}
        </div>
      )}
    </div>
  );
}

export default ButtonsRadioRHF;
